import { Reducer } from 'redux';

import {
  GET_TRIALS_FAILED,
  SET_TRIALS,
  SET_TRIALS_META,
  GET_TRIAL_OPTIONS_FAILED,
  SET_TRIAL_OPTIONS,
  Trial,
  TrialActionTypes,
  TrialState,
  GET_TRIALS,
  GET_ALL_TRIALS,
  GET_ALL_TRIALS_FAILED,
  SET_ALL_TRIALS,
} from './types';

const defaultState: TrialState = {
  allTrials: [],
  trials: [],
  unfilteredCount: 0,
  filteredCount: 0,
  trialOptions: [],
  error: '',
  loading: false,
  allTrialsLoading: false,
  trialsLoaded: false,
  trialsSettledSiteId: null,
};

const reducer: Reducer<TrialState, TrialActionTypes> = (state = defaultState, action) => {
  switch (action.type) {
    case GET_ALL_TRIALS:
      return { ...state, allTrialsLoading: true };
    case GET_ALL_TRIALS_FAILED:
      // Catalog failures stay off `error`. Trial materials renders that field under the table.
      return { ...state, allTrialsLoading: false };
    case SET_ALL_TRIALS: {
      const { trials } = action;
      return {
        ...state,
        allTrials: trials,
        allTrialsLoading: false,
      };
    }
    case GET_TRIALS:
      return { ...state, loading: true, trialsLoaded: false, error: '' };
    case GET_TRIALS_FAILED: {
      const { error, siteId } = action;
      return {
        ...state,
        trials: [],
        unfilteredCount: 0,
        filteredCount: 0,
        error,
        loading: false,
        trialsLoaded: true,
        trialsSettledSiteId: siteId,
      };
    }
    case SET_TRIALS: {
      const { trials, unfilteredCount, filteredCount, siteId } = action;
      return {
        ...state,
        trials,
        unfilteredCount,
        filteredCount,
        error: '',
        loading: false,
        trialsLoaded: true,
        trialsSettledSiteId: siteId,
      };
    }
    case SET_TRIALS_META: {
      const { trials } = state;
      const { latestApplicableAtLookup } = action;

      const updatedTrials = trials.reduce((updatedList, trial) => {
        const latestDocumentApplicableAt = latestApplicableAtLookup[trial.id];
        if (latestDocumentApplicableAt) {
          updatedList.push({ ...trial, $meta: { latestDocumentApplicableAt } });
        } else {
          updatedList.push(trial);
        }

        return updatedList;
      }, [] as Trial[]);

      return {
        ...state,
        trials: updatedTrials,
      };
    }
    case GET_TRIAL_OPTIONS_FAILED: {
      const { error } = action;
      return {
        ...state,
        error,
      };
    }
    case SET_TRIAL_OPTIONS: {
      const { trialOptions } = action;
      return {
        ...state,
        trialOptions,
      };
    }
    default:
      return state;
  }
};

export default reducer;
